import React, { useEffect, useState } from 'react';
import LostCargoSearchProductList from './LostCargoSearchProductList';
import LostCargoSearchForm from './LostCargoSearchForm';
import { SCUIContent } from '../../../atomic/organisms';
import { ReturnCommand } from '../../../services/command';
import { useLocation } from 'react-router-dom';
import { useLostCargoReturnPage, LostCargoReturnPageProvider } from '../context/LostCargoReturnPageContext';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { useTranslation } from 'react-i18next';
import { Grid, CircularProgress, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { LCSR } from '../lostCargoSearchReturnPage.classes';

function LostCargoReturnPageContent() {
    const { t } = useTranslation();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const shippingListNo = query.get('shippingListNo');
    const { returnListData, setReturnListData, searchTrigger } = useLostCargoReturnPage();
    const [loading, setLoading] = useState(false);
    const lostPackageShippingStatus = 18;
    const completedStatus = 22;
    const returnRequestStatus = 8;

    useEffect(() => {
        if (shippingListNo) {
            GetReturnProductList(shippingListNo);
        } else {
            setReturnListData([]);
        }
    }, [shippingListNo, searchTrigger]);

    const GetReturnProductList = async (shippingListNo: string) => {
        setLoading(true);
        let req = {
            shippingListNo: shippingListNo,
        };

        try {
            ReturnCommand.GetReturnProductList(req).then((res: any) => {
                if (res?.data && res?.data?.shippingListForBackofficeModels?.length > 0) {
                    if (
                        (res?.data?.shippingListForBackofficeModels[0]?.statusId == returnRequestStatus &&
                            res?.data?.hasReturnRequest) ||
                        res?.data?.shippingListForBackofficeModels[0]?.statusId == completedStatus
                    ) {
                        window.location.href = `/lost-cargo-return-detail-page?returnId=${res?.data?.returnId}&customerId=${res?.data?.customerId}`;
                    } else if (
                        res?.data?.shippingListForBackofficeModels[0]?.statusId == lostPackageShippingStatus &&
                        !res?.data?.hasReturnRequest
                    ) {
                        setReturnListData(res?.data);
                    } else {
                        Swal.fire({
                            title: t('lostCargoReturnPageBuilder.returnReasonText'),
                            text: t('lostCargoReturnPageBuilder.returnReasonText2'),
                            icon: 'info',
                            iconColor: '#4285F4',
                            timer: 8000,
                            showConfirmButton: true,
                            timerProgressBar: true,
                            background: '#f8f9fa',
                            confirmButtonText: t('lostCargoReturnPageBuilder.ok'),
                            position: 'center',
                        }).then(() => {
                            window.location.href = `/createReturn?orderNumber=${res.data.orderNumber}`;
                        });
                    }
                } else {
                    Swal.fire({
                        title: t('general.error'),
                        text: t('general.noDataFound'),
                        icon: 'error',
                        timer: 1000,
                        showConfirmButton: true,
                    });
                    setReturnListData([]);
                }
            });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <SCUIContent>
                <Box className={LCSR.page}>
                    <Grid
                        className={LCSR.loadingSection}
                        container
                        style={{
                            height: 'calc(100vh - 200px)',
                            width: '100%',
                            margin: 0,
                            padding: 0,
                            marginTop: '-50px',
                        }}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            <CircularProgress size={80} />
                        </div>
                    </Grid>
                </Box>
            </SCUIContent>
        );
    }

    return (
        <SCUIContent>
            <Box className={LCSR.page}>
                <Grid style={{ margin: '0rem' }}>
                    <div className={LCSR.breadcrumbWrap} style={{ marginLeft: '1.5rem' }}>
                        <SCUIBreadCrumb
                            title={t('lostCargoReturnPageBuilder.lostCargoReturnPage')}
                            componentLink={'lost-cargo-return-page'}
                        />
                    </div>
                    {returnListData.shippingListForBackofficeModels ? (
                        <LostCargoSearchProductList />
                    ) : (
                        <LostCargoSearchForm />
                    )}
                </Grid>
            </Box>
        </SCUIContent>
    );
}

function LostCargoReturnPageLayout() {
    return (
        <LostCargoReturnPageProvider>
            <LostCargoReturnPageContent />
        </LostCargoReturnPageProvider>
    );
}

export default LostCargoReturnPageLayout;
